import { useContext } from 'react';
import SelectableContext from '../Contexts/SelectableContext';

const useSelectable = () => useContext(SelectableContext);

export default useSelectable;
